export const facilityLinks = [
  {
    link: 'Overview',
    name: 'Overview',
  },
  {
    link: 'Appointments',
    name: 'Appointments',
  },
  {
    link: 'PatientsRecords',
    name: 'Patients Records',
  },
  {
    link: 'HospitalsRecords',
    name: 'Hospitals Records'
  }
]


export const clientLinks = [
  {
    link: 'Home',
    name: 'Home',
  },
  {
    link: 'Appointments',
    name: 'Appointments',
  },
  {
    link: 'Prescriptions',
    name: 'Prescriptions',
  },
  {
    link: 'MyRecords',
    name: 'My Records',
  },
  {
    link: 'Profile',
    name: 'Profile',
  }
]

export const providerLinks = [
  {
    link: 'Overview',
    name: 'Overview',
  },
  {
    link: 'Appointments',
    name: 'Appointments',
  },
  {
    link: 'Prescriptions',
    name: 'Prescriptions',
  },
  {
    link: 'PatientsRecords',
    name: "Patient's Records",
  },
  {
    link: 'HospitalRecords',
    name: 'Hospital Records',
  }
]

